import { render, staticRenderFns } from "./IconNoContentV52.vue?vue&type=template&id=7c4045d9"
import script from "./IconNoContentV52.vue?vue&type=script&lang=js"
export * from "./IconNoContentV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports